import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import {
  baseUrl,
  customHeaders,
  indianProjectsBaseURL,
  thriweMarketPlacePhillipinesUrl,
  thriweMarketPlaceUaeUrl,
  thriweMarketPlaceUrl,
  uaeProjectsBaseURL,
} from '../../../../Containers/Config/index.js';
import { DOWNLOAD_BOOKING_V2, DOWNLOAD_BOOKING_V2_SUCCESS, DOWNLOAD_BOOKING_V2_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* downloadDumpV2({ payload }) {
  try {
    const isUaeProject = [
      'HSBC_BEACH_CLUB',
      'ENBD_NATIONAL_DAY',
      'MASTERCARD_FAB',
      'CBD_GOLF_V2',
      'VISA_PVT',
      'MASTERCARD_UAE',
      'MASHREQ',
      'EIB_V2',
    ].includes(Constant.PROJECT_CODE);
    const baseUrl = isUaeProject
      ? thriweMarketPlaceUaeUrl
      : ['HSBC_BENEFITS'].includes(Constant.PROJECT_CODE)
        ? thriweMarketPlacePhillipinesUrl
        : thriweMarketPlaceUrl;

    // Determine the user type (client or admin) based on clientType
    const userType = Constant.userTypes.CLIENT === Number(localStorage.getItem('userType')) ? 'client' : 'admin';

    // Construct the full URL dynamically using template literals
    const downloadUrl = `${baseUrl}/v1/${userType}/download-booking`;

    const response = yield call(apiCall, {
      url: downloadUrl,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: DOWNLOAD_BOOKING_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: DOWNLOAD_BOOKING_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_BOOKING_V2_ERROR, payload: error });
  }
}

export function* watchdownloadDumpV2() {
  yield takeEvery(DOWNLOAD_BOOKING_V2, downloadDumpV2);
}

function* downloadDumpV2Saga() {
  yield all([fork(watchdownloadDumpV2)]);
}

export default downloadDumpV2Saga;
